var map = {
	"./da.json": 49914,
	"./da2.json": 180,
	"./de.json": 95894,
	"./en.json": 44174,
	"./en2.json": 29904,
	"./es.json": 46725,
	"./es2.json": 16005,
	"./fi.json": 46808,
	"./nb.json": 49093,
	"./nb2.json": 46821,
	"./sv.json": 28252,
	"./sv2.json": 16030,
	"./zh-hans.json": 87190,
	"./zh-hans2.json": 50504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;